module.exports = __webpack_public_path__ + "static/media/Grid4.8e3f1c7b.png";